import * as React from "react";
import { VingleURL } from "@vingle/wtf-sdk/url";
import CompactCard from "common/components/compactCard";
import translateAppURLToURL from "@vingle/wtf-sdk/helpers/translateAppURLToURL";
import getPreviewContent from "app/discover/helpers/getPreviewContent";

function SectionContentCard({
  content,
  sectionId,
  position,
}: {
  content: Vingle.Discover.IDiscoverContent;
  sectionId: string;
  position: number;
}) {
  const texts = React.useMemo(() => getPreviewContent(content), [content]);
  return (
    <CompactCard
      key={content.url}
      link={{
        pathname: translateAppURLToURL(content.url),
        state: {
          modal: true,
        },
      }}
      title={content.title}
      content={texts}
      description={content.desc.text}
      media={{
        type: "image",
        src: content.thumbnail,
      }}
      trackTicket={{
        contentType: "url",
        contentId: content.url,
        position,
        referralUrl: new VingleURL.DiscoverTrendingSection({
          sectionId,
        }).toSchema(),
      }}
    />
  );
}

export default React.memo(SectionContentCard);
